import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"

const gsapSummaryBoxFixed = {};

gsapSummaryBoxFixed.init = () => {
    gsap.registerPlugin(ScrollTrigger);

    let fixedElem = ".js-gsap-fixed-ecommerce-box";

    if (document.querySelector(fixedElem)) {

        let mainScene;

        ScrollTrigger.matchMedia({

            // tablet/mobile only
            "(max-width: 1023px)": function() {

                mainScene = function() {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: 'main',
                            start: "bottom bottom",
                            toggleActions: "play none none reset",
                            // markers: true
                        }
                    });
                    tl.to(fixedElem, {
                        position:'absolute',
                        bottom: 0,
                    });
                    return tl;
                }

                let masterTimeline = gsap.timeline()
                    .add(mainScene())

            }

        })

    }

};

export default gsapSummaryBoxFixed;
